var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowForwardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33335 15.4167C6.62611 15.4167 5.94783 15.1357 5.44774 14.6356C4.94764 14.1355 4.66669 13.4573 4.66669 12.75C4.66669 12.0428 4.94764 11.3645 5.44774 10.8644C5.94783 10.3643 6.62611 10.0834 7.33335 10.0834H15.0025L13.0429 12.0429C12.6524 12.4334 12.6524 13.0666 13.0429 13.4571C13.4334 13.8477 14.0666 13.8477 14.4571 13.4571L18.1238 9.79046C18.5143 9.39994 18.5143 8.76677 18.1238 8.37625L14.4571 4.70958C14.0666 4.31906 13.4334 4.31906 13.0429 4.70958C12.6524 5.1001 12.6524 5.73327 13.0429 6.12379L15.0025 8.08335H7.33335C6.09568 8.08335 4.90869 8.57502 4.03352 9.45019C3.15835 10.3254 2.66669 11.5123 2.66669 12.75C2.66669 13.9877 3.15835 15.1747 4.03352 16.0499C4.90869 16.925 6.09568 17.4167 7.33335 17.4167H8.25002C8.80231 17.4167 9.25002 16.969 9.25002 16.4167C9.25002 15.8644 8.80231 15.4167 8.25002 15.4167H7.33335Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForwardIcon);
export default __webpack_public_path__ + "static/media/ArrowForwardIcon.f4ec5f5fdd96925372ea45a4e6f94206.svg";
export { ForwardRef as ReactComponent };